import React, { memo, useMemo } from "react";

const SummaryCard = ({ title, mainText, expiry, status }) => {
  const badgeStyle = useMemo(() => ({
    width: "100%",
    height: "32px",
    marginTop: "12px",
    background: status === "ACTIVE" ? "#DCFFE8" : "#FFEEF3",
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  }), [status]);

  const dotStyle = useMemo(() => ({
    width: "10px",
    height: "10px",
    background: status === "ACTIVE" ? "#1F8F4A" : "#FF4444",
    borderRadius: "50%",
    display: "inline-block",
  }), [status]);

  const textStyle = useMemo(() => ({
    fontSize: "16px", // kept as per original string '16px', though number 16 works too usually
    fontWeight: 500,
    color: "#0F3D2E",
  }), []);

  return (
    <div className="summary-card p-3 rounded-4 border">
      <small className="fs-11 fw-700 font-color-lt_grey text-uppercase">
        {title}
      </small>

      <div
        className="fw-600 font-color-dk_blk fs-14 mt-2 text-truncate"
        style={{ maxWidth: "250px" }}
        title={mainText}
      >
        {mainText ?? "-"}
      </div>

      <div className="fs-12 font-color-lt_grey mt-1">
        Exp.: <span className="text-danger">{expiry ?? "-"}</span>
      </div>

      <div style={badgeStyle}>
        <span style={dotStyle} />
        <span style={textStyle}>
          {status}
        </span>
      </div>
    </div>
  );
};

export default memo(SummaryCard);
